import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {FooterButton} from "./footer-button";

@Component({
  selector: 'pf-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Input() backButton?: FooterButton;
  @Input() forwardButton?: FooterButton;
  @Input() storeButton?: FooterButton;

  @Output() backButtonClicked = new EventEmitter<void>();
  @Output() storeButtonClicked = new EventEmitter<void>();
  @Output() forwardButtonClicked = new EventEmitter<void>();

  forward(event: MouseEvent) {
    event.preventDefault();
    if (!this.forwardButton.disabled) {
      this.forwardButtonClicked.emit();
    }
  }

  back(event: MouseEvent): void {
    event.preventDefault();
    if (!this.backButton.disabled) {
      this.backButtonClicked.emit();
    }
  }

  store(event: MouseEvent): void {
    event.preventDefault();
    if (!this.storeButton.disabled) {
      this.storeButtonClicked.emit();
    }
  }
}
